const URLs = {
  API: "https://www.vasanthammatrimonyudt.com",
};

export default URLs;
